var GoogleAuthProvider = (function () {
    function GoogleAuthProvider() {
    }
    GoogleAuthProvider.TYPE = "oauth2-google";
    GoogleAuthProvider.DEFAULT_NAME = "oauth2-google";
    return GoogleAuthProvider;
}());
export default GoogleAuthProvider;
//# sourceMappingURL=GoogleAuthProvider.js.map